export enum Roles {
  TelephonyAdminWrite = "role:telephony_admin_write",
  TelephonyAdminRead = "role:telephony_admin_read",
  GlobalAdmin = "role:global_admin",
  BillingAdmin = "role:billing_admin",
  ReportingAdmin = "role:reporting_admin",
  TelephonyAdmin = "role:telephony_admin",
}
